import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Link,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { Close, Hamburger } from '@/client/components/icons/ContinuIcons';
import { useEffect, useRef } from 'react';

import { HUB_SESSION_BANNER_HEIGHT } from '@/client/components/shared/messaging/HubSessionBanner';
import Logo from '@/client/components/media/images/Logo';
import { Link as RouterLink } from 'react-router-dom';
import SideNav from './side-navigation/SideNav';
import UserMenu from './UserMenu';
import { useIsActiveHubSession } from '@/client/services/state/hubSessionStore';

export default function MainNav() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const iconBtnRef = useRef<HTMLButtonElement>(null);
  const isHubSession = useIsActiveHubSession();

  const breakpoint = useBreakpointValue({ base: 'base', lg: 'lg' });

  useEffect(() => {
    if (breakpoint === 'lg') {
      onClose();
    }
  }, [breakpoint]);

  return (
    <Flex
      data-testid="main-nav"
      height="80px"
      alignItems="center"
      justifyContent="space-between"
      paddingX={4}
      borderBottom="1px"
      borderBottomColor="gray.100"
      backgroundColor="white"
      width="full"
      position="fixed"
      // Shifted down while the hub session banner (fixed above, zIndex 1100) shows
      top={isHubSession ? HUB_SESSION_BANNER_HEIGHT : 0}
      zIndex={100}
      id="mainNav"
    >
      <IconButton
        size="md"
        icon={isOpen ? <Close /> : <Hamburger />}
        aria-label="Open Menu"
        display={{ lg: 'none' }}
        onClick={isOpen ? onClose : onOpen}
        backgroundColor="transparent"
        color="blackAlpha.800"
        _hover={{
          backgroundColor: 'transparent',
          color: 'brand.primary',
        }}
        _active={{
          backgroundColor: 'transparent',
          color: 'brand.primary',
        }}
        ref={iconBtnRef}
      />

      <HStack spacing={10} alignItems="center" height="100%">
        <Link as={RouterLink} to="/explore">
          <Logo variant="explore" />
        </Link>
      </HStack>

      <UserMenu />

      <Drawer isOpen={isOpen} placement="left" onClose={onClose} finalFocusRef={iconBtnRef}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          <DrawerBody padding={0}>
            <SideNav initialOpen />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
